import { render } from "./FloatingView.vue?vue&type=template&id=d2ae070a"
import script from "./FloatingView.vue?vue&type=script&lang=js"
export * from "./FloatingView.vue?vue&type=script&lang=js"

import "./FloatingView.vue?vue&type=style&index=0&id=d2ae070a&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__